// extracted by mini-css-extract-plugin
export default {"container":"SpeakerView_container__r47TL"};